// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"0ffdb3ec","239":"48d1931b","339":"7bb3e2b0","389":"05c498b7","455":"e2d207e0","535":"b5be3bf0","551":"e02c57c7","621":"4136ea3e","640":"2372e2c5","672":"aade62b0","828":"40f8e735","842":"86923895","977":"c230cbfa"}[chunkId] + ".chunk.js";
};